export default __webpack_public_path__ + "static/media/yuukke-logo.da2a72b2.png";